import CControl from "./CControl";
import { CForm } from "./JSForm";
import { DateTime } from "ioip-base/lib/common";
import { isNullOrEmpty } from "@ioip/core/lib";
import { IFieldSchema } from "./IFieldSchema";

export interface ICDatePickerProps {
    form: CForm;
    schema: IFieldSchema;
}

class CDatePicker extends CControl {

    #props: ICDatePickerProps;
    #minValue: DateTime;
    #maxValue: DateTime;

    constructor(props: ICDatePickerProps) {
        super({ form: props.form, schema: props.schema });
        this.#props = props;
    }

    get label(): string {
        return this.#props.schema.label;
    }

    get placeholder(): string {
        return this.#props.schema.placeholder;
    }

    get minValue(): DateTime {
        if (isNullOrEmpty(this.#props.schema.minValue))
            return null;
        if (this.#minValue == null)
            this.#minValue = new DateTime(this.#props.schema.minValue);
        return this.#minValue;
    }

    get maxValue(): DateTime {
        if (isNullOrEmpty(this.#props.schema.maxValue))
            return null;
        if (this.#maxValue == null)
            this.#maxValue = new DateTime(this.#props.schema.maxValue);
        return this.#maxValue;
    }

}

export default CDatePicker;